export default __webpack_public_path__ + "static/media/IMG-20250105-WA0005.3444542f.jpg";